import React from 'react';
import Tippy, { TippyProps } from '@tippy.js/react';

import 'tippy.js/themes/light.css';
import 'tippy.js/dist/tippy.css';

export default function Tooltip({
  children,
  content,
  interactive = false,
  theme = 'light',
  zIndex = 9999, // default z-index (https://atomiks.github.io/tippyjs/v5/all-props/)
  ...rest
}: TippyProps): JSX.Element {
  return (
    <Tippy theme={theme} content={content} interactive={interactive} zIndex={zIndex} {...rest}>
      {children}
    </Tippy>
  );
}
